// React and related imports
import React from 'react';

// Types and Interfaces
import { languageOptions } from '../../../common/constants/languageOptions';

// Flowbite components
import { Button, Dropdown } from 'flowbite-react';

// Flag Component
import Flag from 'react-world-flags';

interface LanguageDropdownProps {
  selectedLanguage: (typeof languageOptions)[0];
  onSelectLanguage: (lang: (typeof languageOptions)[0]) => void;
  isDarkMode: boolean;
}

export const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  selectedLanguage,
  onSelectLanguage,
  isDarkMode,
}) => (
  <Dropdown
    arrowIcon={false}
    inline
    label={
      <Button
        size="xs"
        className={`btn mt-3 flex w-40 items-center ${isDarkMode ? 'btn-dark' : 'btn-light'}`}
        as={'span'}
      >
        <Flag
          code={selectedLanguage.flagCode}
          className="me-2 h-4 w-4 rounded-full"
        />
        <span>{selectedLanguage.label}</span>
      </Button>
    }
  >
    {languageOptions.map((lang) => (
      <Dropdown.Item
        key={lang.languageCode}
        onClick={() => onSelectLanguage(lang)}
        disabled={lang.languageCode === selectedLanguage.languageCode}
        className={`${
          lang.languageCode === selectedLanguage.languageCode
            ? 'cursor-not-allowed opacity-50'
            : ''
        }`}
      >
        <Flag code={lang.flagCode} className="me-2 h-3.5 w-3.5 rounded-full" />
        <span>{lang.label}</span>
      </Dropdown.Item>
    ))}
  </Dropdown>
);
